import { company, whatsappAskHref } from '@/content/company';

const WEBCHAT_BUBBLE_ID = 'operax-webchat-bubble';

/** Mensagem padrão ao abrir WhatsApp a partir do FAQ/preços. */
export const SUPPORT_ASK_MESSAGE =
  'Oi! Tenho dúvidas sobre os planos da Operax (sem teste grátis). Podem me ajudar?';

export function supportWhatsAppHref(message = SUPPORT_ASK_MESSAGE): string {
  return whatsappAskHref(message);
}

/**
 * Abre o chat embutido do site (widget Operax).
 * Se o widget ainda não carregou, cai no WhatsApp.
 */
export function openSupportChat(fallbackMessage = SUPPORT_ASK_MESSAGE): 'chat' | 'whatsapp' {
  const bubble = document.getElementById(WEBCHAT_BUBBLE_ID) as HTMLButtonElement | null;
  if (bubble) {
    const open = bubble.getAttribute('aria-label') === 'Fechar chat';
    if (!open) bubble.click();
    return 'chat';
  }
  window.open(supportWhatsAppHref(fallbackMessage), '_blank', 'noopener,noreferrer');
  return 'whatsapp';
}

export const supportChannelsLabel = `Chat no site ou WhatsApp ${company.phoneDisplay}`;
